import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { OrganizationFacade } from '../../../../shared/state/organization/facades/organization.facade';
import { CONFIGURE_GUIDELINES_MODAL_ID } from '../../constants/organization-constants';
import { IOrganization, IOrganizationPatch } from '../../../../shared/models/organization';
import { DialogService } from '../../../../shared/services/dialog.service';
import { FontAwesomeSharedModule } from '../../../../shared/font-awesome/font-awesome';

@Component({
  selector: 'app-configure-guidelines-modal',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FontAwesomeSharedModule],
  templateUrl: './configure-guidelines-modal.component.html',
})
export class ConfigureGuidelinesModalComponent {
  private fb = inject(FormBuilder);
  private organizationFacade = inject(OrganizationFacade);
  private dialogService = inject(DialogService);

  modalId = CONFIGURE_GUIDELINES_MODAL_ID;
  organization: IOrganization | null = null;

  guidelinesForm: FormGroup = this.fb.group({
    request_guidelines_enabled: false,
    request_guidelines_catalog_text: [''],
    request_guidelines_modal_text: [''],
    request_guidelines_url: [''],
  });

  /** Loads the organization's current guidelines into the form and opens the modal. */
  open(organization: IOrganization): void {
    this.organization = organization;
    this.guidelinesForm.reset({
      request_guidelines_enabled: organization.request_guidelines_enabled ?? false,
      request_guidelines_catalog_text: organization.request_guidelines_catalog_text ?? '',
      request_guidelines_modal_text: organization.request_guidelines_modal_text ?? '',
      request_guidelines_url: organization.request_guidelines_url ?? '',
    });
    this.dialogService.open(CONFIGURE_GUIDELINES_MODAL_ID);
  }

  closeModal(): void {
    this.dialogService.close(CONFIGURE_GUIDELINES_MODAL_ID);
  }

  onSubmit(): void {
    if (!this.organization || this.guidelinesForm.invalid) return;
    const value = this.guidelinesForm.value;
    const patch: IOrganizationPatch = {
      request_guidelines_enabled: value.request_guidelines_enabled ?? false,
      request_guidelines_catalog_text: value.request_guidelines_catalog_text ?? '',
      request_guidelines_modal_text: value.request_guidelines_modal_text ?? '',
      request_guidelines_url: value.request_guidelines_url ?? '',
    };
    this.organizationFacade.patchOrganization(this.organization.id, patch);
    this.dialogService.close(CONFIGURE_GUIDELINES_MODAL_ID);
  }
}
